import { DISPLAY_CLASSES, POSITION_CLASSES, customTV } from '../../utils/tailwind';
import { ANIMATION_CLASSES } from '../../utils/tailwind/animation';
import { OVERFLOW_CLASSES } from '../../utils/tailwind/overflow';
import { BOX_SHADOW_ELEVATION_CLASSES } from '../../utils/tailwind/shadowElevation';
export const box = customTV({
    base: 'box-border',
    variants: {
        display: DISPLAY_CLASSES,
        position: POSITION_CLASSES,
        overflow: OVERFLOW_CLASSES,
        animation: ANIMATION_CLASSES,
        shadowElevation: BOX_SHADOW_ELEVATION_CLASSES,
        border: {
            true: 'border border-solid border-transparent',
        },
    },
});
